import React, { useState, useEffect } from "react";
import { MultiSelect } from "primereact/multiselect";
import AreaBoxes from "./AreaBoxes";
import { AREA_LIST_URL, FETCH_AI_MODEL, FETCH_INSTANCE_LIST } from "../../apiClient/apiEndpoints";
import apiClient from "../../apiClient/apiClient";
import { useSelector } from "react-redux";
import { CloseIcon } from "../../assets/Icons";

const Monitoring = () => {
  const [areaOptions, setAreaOptions] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [instanceList, setInstanceList] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  const [selectedModel, setSelectedModel] = useState([]);
  const configData = useSelector((state) => state?.config);
  const API_URL = configData?.config?.API_URL;
  const [loading, setLoading] = useState({
    area: true,
    model: true,
    areaBoxes: true
  });

  const fetchAreaList = async () => {
    const res = await apiClient.get(`${API_URL}${AREA_LIST_URL}`);
    const areaOptions = res.map((item) => ({ name: item?.name, code: item?.uuid }));
    setAreaOptions(areaOptions);
    setLoading(prev => ({ ...prev, area: false }))
  };

  const fetchModelList = async () => {
    const res = await apiClient.get(`${API_URL}${FETCH_AI_MODEL}`);
    const options = res.map((item) => ({ name: item?.name, code: item?.uuid }));
    setModelList(options);
    setLoading(prev => ({ ...prev, model: false }))
  };

  const fetchInstanceList = async () => {
    const queryParams = {};
    if (selectedArea?.length > 0) {
      queryParams.area = selectedArea.map((item) => item.code);
    }
    if (selectedModel?.length > 0) {
      queryParams.modelId = selectedModel.map((item) => item.code);
    }
    const res = await apiClient.get(`${API_URL}${FETCH_INSTANCE_LIST}`, { params: queryParams });
    setInstanceList(res);
    setLoading(prev => ({ ...prev, areaBoxes: false }))
  };

  const onClearClick = (value = "") => {
    if (value === "model") {
      setSelectedModel([]);
      return
    }
    setSelectedArea([]);
  };

  useEffect(() => {
    fetchAreaList();
    fetchModelList();
  }, []);

  useEffect(() => {
    fetchInstanceList();
  }, [selectedArea, selectedModel]);

  return (
    <div className="container-fluid admindashboard p-4 pt-4 bg-grey-main">
      <div className="row align-items-center mt-0 ps-2 mb-2">
        <div className="page-title">
          <h6>Instances</h6>
          <div className="d-flex align-item-center justify-content-end gap-3">
            <div className="card flex justify-content-center prime-select">
              {selectedArea.length > 0 && (
                <span className="dselect" onClick={onClearClick}>
                  <CloseIcon />
                </span>
              )}
              <MultiSelect
                loading={loading?.area ? true : false}
                value={selectedArea}
                onChange={(item) => setSelectedArea(item.value)}
                options={areaOptions}
                optionLabel="name"
                placeholder={loading?.area ? "Loading..." : "Select Area"}
                maxSelectedLabels={1}
                className="w-full"
                style={{ minWidth: "15rem" }}
                filter
              />
            </div>
            <div className="card flex justify-content-center prime-select">
              {selectedModel.length > 0 && (
                <span className="dselect" onClick={() => onClearClick("model")}>
                  <CloseIcon />
                </span>
              )}
              <MultiSelect
                loading={loading?.model ? true : false}
                value={selectedModel}
                onChange={(item) => setSelectedModel(item.value)}
                options={modelList}
                optionLabel="name"
                placeholder={loading?.model ? "Loading..." : "Select Model"}
                maxSelectedLabels={1}
                className="w-full"
                style={{ minWidth: "15rem" }}
                filter
              />
            </div>
          </div>
        </div>
        <AreaBoxes instanceList={instanceList} loading={loading.areaBoxes} modelList={modelList}/>
      </div>
    </div>
  );
};

export default Monitoring;
